import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined'
import Dialog from '@components/atoms/dialog'
import IconButton from '@material-ui/core/IconButton'
import ButtonCta from '@components/atoms/button-cta'
import { useStyles } from './styles'
import JoinWaitlistForm from './join-waitlist-form'

const JoinWaitlistDialog = (props) => {
  const {
    trigger,
    eventId,
    onOpen,
    onSuccess,
  } = props
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const styles = useStyles()

  const FormDisplay = () => (
    <Box className={styles.formContainer}>
      <IconButton className={styles.iconBig}>
        <AssignmentLateOutlinedIcon fontSize="large" />
      </IconButton>
      <Typography variant="h3" gutterBottom>Join the Waitlist!</Typography>
      <Typography variant="body1" style={{ fontWeight: 600 }}>
        Enter your email address to be added to the waitlist.
        If a spot opens up, you will receive an email notification.
      </Typography>
      <JoinWaitlistForm groupEventId={eventId} setIsFormSubmitted={setIsFormSubmitted} onSuccess={onSuccess} />
    </Box>
  )

  const JoinWaitlistFormSuccessDisplay = () => (
    <Box className={styles.formContainer}>
      <IconButton className={styles.iconBig}>
        <AssignmentLateOutlinedIcon fontSize="large" />
      </IconButton>
      <Typography variant="h3" gutterBottom>You&apos;re on the Waitlist!</Typography>
      <Typography variant="body1" style={{ fontWeight: 600 }}>
        We will email you if a spot on this events opens up. In the meantime, are you
        ready “fore” some golfing fun? Download the MyPGA app to find more events near you!
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center" my={4}>
        <ButtonCta
          variant="contained"
          color="primary"
          href="/things-to-do/search"
          className={styles.fitContent}
        >
          Find Events Near Me
        </ButtonCta>
        <Button
          variant="outlined"
          color="secondary"
          href={`${process.env.MY_PGA_COM_URL}/club`}
          target="_blank"
          className={styles.fitContent}
          style={{ marginTop: '1rem' }}
        >
          Create Account
        </Button>
      </Box>
    </Box>
  )

  return (
    <Dialog
      trigger={trigger}
      maxWidth="md"
      onClose={() => setTimeout(() => { setIsFormSubmitted(false) }, 500)}
      showCloseButton
      onOpen={onOpen}
    >
      {() => (
        isFormSubmitted
          ? <JoinWaitlistFormSuccessDisplay />
          : <FormDisplay />
      )}
    </Dialog>
  )
}

JoinWaitlistDialog.propTypes = {
  trigger: PropTypes.element.isRequired,
  eventId: PropTypes.string.isRequired,
  onOpen: PropTypes.func,
  onSuccess: PropTypes.func,
}

export default JoinWaitlistDialog
